import React, {useEffect, useState} from 'react';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import FinishTick from '../Assets/SVG/FinishTick';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from 'app/Config';

const SuccessScreen = (props) => {
  return (
    <>
      <FinishTick />
      <div className='headBox'>
        <p className='heading'>יש בינינו חיבור!</p>
        <p className='subHeading'>
          ההתקנה הצליחה ואפשר להתחיל <br />
          לגלוש ברשת החדשה שלך
        </p>
      </div>
      <div className='fixFooter'>
        <BtnSubmit
          className='mb-12'
          text={'סיום'}
          onclick={() => {
            prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl);
          }}
        />
      </div>
    </>
  );
};

export default SuccessScreen;
